module.exports = __webpack_public_path__ + "static/img/notxnv.0d902a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notxnv.png
// module id = KMeU
// module chunks = 1